"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = exports.InfoContent = void 0;
const app_1 = require("@obvio/app");
const Stack_1 = require("../../../Stack");
exports.InfoContent = (0, app_1.styled)(Stack_1.Stack) `
  align-items: center;
`;
exports.Info = (0, app_1.styled)(Stack_1.Stack) `
  width: 100%;
  align-items: center;
  a {
    color: ${(theme) => theme.colors.primary};
  }
  span {
    color: ${(theme) => theme.colors.gray.semidark};
  }
`;
